/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */
export const ImageUploadTypes = {
    default: "default" as const,
    image: "image" as const
};

export type ImageUploadTypes = typeof ImageUploadTypes[keyof typeof ImageUploadTypes];
